import Mark from "./Mark.ts";
import IMark from "../interfaces/IMark.ts";
import MarkText from "../components/MarkText.ts";
import DecodingModel from "../models/DecodingModel.ts";
import {Container, Graphics, Sprite, Text, TextStyle} from "pixi.js";
import RhColors from "@/models/RhColors.ts";

export default class PlaceholderMark extends Mark implements IMark
{

    constructor(targetTextField?:MarkText, color=RhColors.MARK_PRIMARY)
    {
        super(color);
        this.targetTextField = targetTextField;
        if(this.targetTextField)
        {
            this.parentTarget = this.targetTextField;
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        const text = ":(";
        const style = new TextStyle({
            fontFamily: DecodingModel.getInstance().fontFamily,
            fontSize: 100,
            fill: color,
            align: 'center'
        });
        let mark = new Text({text:text, style:style});
        //const metrics = TextMetrics.measureText(text, style);
        this.markWidth = mark.width;
        this.markHeight = mark.height;
        mark.visible = visible;
        this.addChild(mark);
        //mark.cacheAsBitmap = true;
        return mark;
    }

    public override create():void
    {
        this.createMarks();
    }

    public createMarks()
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

}